import React from 'react';
import PropTypes from 'prop-types';

import api from '../../api/api';
import Cookies from 'universal-cookie';
import { processError } from '../../lib/lib';

import { Row, Col, Container, Button } from 'reactstrap';
import { EnvelopeSimple, Spinner } from 'phosphor-react';
import { withTranslation } from 'react-i18next';
import getSystemFrontendSettings from '../../lib/systemFrontendSettings';

const cookies = new Cookies();

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line no-undef
      fileUrl: process.env.REACT_APP_FILEURL,
      // eslint-disable-next-line no-undef
      template: process.env.REACT_APP_TEMPLATE,
      contactPhone: '+7 (499) 111-22-33',
      contactMail: '',
      email: '',
      subscribed: false,
      checkSubscriptionAction: false,
      footerDocs: [],
    };
    this.checkSubscription = this.checkSubscription.bind(this);
    this.changeEmail = this.changeEmail.bind(this);
    this.openDoc = this.openDoc.bind(this);
    this.setContactMail = this.setContactMail.bind(this);
  }

  openDoc(url) {
    window.open(`${this.state.fileUrl}/${url}`, '_blank');
  }

  changeEmail(e) {
    this.setState({ email: e.target.value });
  }

  checkSubscription(e) {
    e.preventDefault();
    this.setState({ checkSubscriptionAction: true });
    const token = cookies.get('accessToken');
    const lang = this.props.i18n.language;
    const subscribed = this.state.subscribed;
    const email = this.state.email;
    if (subscribed)
      api
        .unsubscribe({ token, lang })
        .then(() =>
          this.setState({ subscribed: false, checkSubscriptionAction: false })
        )
        .catch((e) => processError(e, this.props.history));
    else
      api
        .subscribe({ email, token, lang })
        .then(() =>
          this.setState({ subscribed: true, checkSubscriptionAction: false })
        )
        .catch((e) => processError(e, this.props.history));
  }

  setContactMail(lang) {
    let contactMail;
    switch (this.state.template) {
      case 'academy':
        contactMail = `${lang}-support@academyprivateinvestment.com`;
        break;
      case 'wodcom':
        contactMail = 'info@wodcom.online';
        break;
      default:
        contactMail = `${lang}-support@academyprivateinvestment.com`;
        break;
    }
    this.setState({ contactMail });
  }

  componentWillMount() {
    const token = cookies.get('accessToken');
    const lang = this.props.i18n.language;
    this.setContactMail(lang);
    api
      .checkSubscription({ token, lang })
      .then((result) => {
        if (result) this.setState({ subscribed: true });
        else this.setState({ subscribed: false });
      })
      .catch((e) => processError(e, this.props.history));
    getSystemFrontendSettings({ lang })
      .then((result) => {
        if (result) this.setState({ footerDocs: result.footerDocs });
      })
      .catch((e) => processError(e, this.props.history));
  }

  render() {
    const { t } = this.props;
    return (
      <footer
        className={
          'footer' +
          (this.props.default ? ' footer-default footer-bg' : ' footer-bg')
        }
      >
        <div className="footer-wrapper">
          <Container fluid className="footer-container">
            <Row className="footer-row">
              <Col lg={3} md={5} xs={12}>
                <div className="pb-37px">
                  <span className="footer-header unclickable">
                    {t('footer-contacts')}
                  </span>
                </div>

                <div
                  className={`footer-contact ${
                    t('footer-contact-phone') ? 'd-none' : 'd-none'
                  }`}
                >
                  <a
                    className="footer-contact-info"
                    href={`tel:${t('footer-contact-phone')}`}
                  >
                    {t('footer-contact-phone')}
                  </a>
                </div>
                <div
                  className={`footer-contact ${
                    this.state.contactMail ? '' : 'd-none'
                  }`}
                >
                  <a
                    className="footer-contact-info"
                    href={`mailto:${this.state.contactMail}`}
                  >
                    {t('footer-contact-mail-text')}
                  </a>
                </div>
              </Col>
              <Col lg={2} md={4} xs={12}>
                <div className="pb-37px">
                  <a href="/catalog/1" className="a-tag-clean footer-header">
                    {t('footer-catalog')}
                  </a>
                </div>
                <div className="pb-16px">
                  <div
                    onClick={() => {
                      this.props.history.push({
                        pathname: '/catalog/1',
                        state: { filters: [{ name: 'type', values: ['1'] }] },
                      });
                      window.location.reload();
                    }}
                    className="a-tag-clean footer-links"
                  >
                    {t('footer-programs')}
                  </div>
                </div>
                <div className="pb-16px">
                  <div
                    onClick={() => {
                      this.props.history.push({
                        pathname: '/catalog/1',
                        state: { filters: [{ name: 'type', values: ['2'] }] },
                      });
                      window.location.reload();
                    }}
                    className="a-tag-clean footer-links"
                  >
                    {t('footer-courses')}
                  </div>
                </div>
              </Col>
              <Col lg={2} md={3} xs={12}>
                <div className="pb-37px">
                  <div
                    onClick={() => this.props.history.push('/main')}
                    className="a-tag-clean footer-header"
                  >
                    {t('footer-main')}
                  </div>
                </div>
                <div className="pb-16px">
                  <div
                    onClick={() => this.props.history.push('/events')}
                    className="a-tag-clean footer-links"
                  >
                    {t('footer-events')}
                  </div>
                </div>
                <div className="pb-16px">
                  <div
                    onClick={() => this.props.history.push('/stories')}
                    className="a-tag-clean footer-links"
                  >
                    {t('footer-story')}
                  </div>
                </div>
                <div className="pb-16px">
                  <div
                    onClick={() => this.props.history.push('/sale/1')}
                    className="a-tag-clean footer-links"
                  >
                    {t('footer-sale')}
                  </div>
                </div>
              </Col>
              <Col lg={2} md={6} xs={12}>
                <div className="pb-37px">
                  <div
                    onClick={() => this.props.history.push('/news/1')}
                    className="a-tag-clean footer-header"
                  >
                    {t('footer-news')}
                  </div>
                </div>
                <div className="pb-16px">
                  <div
                    onClick={() => this.props.history.push('/webinars')}
                    className="a-tag-clean footer-links"
                  >
                    {t('footer-webinars')}
                  </div>
                </div>
                <div className="pb-16px">
                  <div
                    onClick={() => this.props.history.push('/logs/1')}
                    className="a-tag-clean footer-links"
                  >
                    {t('footer-sessions')}
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} xs={12}>
                <div className="footer-header pb-37px unclickable">
                  {t('footer-subscribe')}
                </div>
                {this.state.subscribed ? (
                  <Button
                    type="button"
                    className="btn profile-avatar-btn primary btn-secondary footer-subscribe-form-btn"
                    disabled={this.state.checkSubscriptionAction}
                    onClick={this.checkSubscription}
                  >
                    {this.state.checkSubscriptionAction ? (
                      <Spinner size="sm" />
                    ) : (
                      <React.Fragment>
                        <EnvelopeSimple size={16} color="#FFFFFF" />
                        <span className="footer-submit-text">
                          {t('footer-unsubscribe')}
                        </span>
                      </React.Fragment>
                    )}
                  </Button>
                ) : (
                  <form
                    className="footer-subscribe-form"
                    onSubmit={this.checkSubscription}
                  >
                    <div className="form-group footer-subscribe-form-group">
                      <input
                        type="email"
                        required
                        className="form-control footer-subscribe-form-control"
                        id="subscribeEmail"
                        aria-describedby="emailHelp"
                        placeholder={t('footer-inputEmail')}
                        value={this.state.email}
                        onChange={this.changeEmail}
                      />
                    </div>
                    <Button
                      type="submit"
                      className="btn profile-avatar-btn primary btn-secondary footer-subscribe-form-btn"
                      disabled={this.state.checkSubscriptionAction}
                    >
                      {this.state.checkSubscriptionAction ? (
                        <Spinner size="sm" />
                      ) : (
                        <React.Fragment>
                          <EnvelopeSimple size={16} color="#FFFFFF" />
                          <span className="footer-submit-text">
                            {t('footer-subscribe')}
                          </span>
                        </React.Fragment>
                      )}
                    </Button>
                  </form>
                )}
              </Col>
            </Row>
            <hr className="footer-hr" />
            <Row className="footer-row footer-policy">
              <Col lg={12}>
                <div className="footer-docs footer-links">
                  {this.state.footerDocs.map((doc, index) => {
                    const condition =
                      doc && typeof doc === 'object' && doc.title && doc.url;

                    const last =
                      index === this.state.footerDocs.length - 1 ? true : false;
                    return (
                      <React.Fragment key={index}>
                        {condition ? (
                          <div
                            className={`doc${last ? ' last' : ''}`}
                            onClick={() => this.openDoc(doc.url)}
                          >
                            {doc.title}
                          </div>
                        ) : (
                          ''
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
                {/* <div className="footer-private-policy">{t('footer-policy')}</div> */}
              </Col>
            </Row>
          </Container>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
  t: PropTypes.func,
  i18n: PropTypes.object,
  history: PropTypes.object,
};

export default withTranslation()(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx